export default __webpack_public_path__ + "static/causa-global-cancer-infantil-bfa2fded5f4d83fbc1498766602f0efb.png";